export default "__VITE_ASSET__DOHOcKLc__"